
import { Injectable } from '@angular/core';
import {SOAPClient,SOAPClientParameters} from './soapclient';

@Injectable()
export class SoapService {
    
public soapParams:any;
public soapClient:any;
    constructor() {}
  
     post(url, action, params){
      this.soapParams = new SOAPClientParameters;
      this.soapClient = SOAPClient; 
       return new Promise((resolve, reject) => {			
              //Create SOAPClientParameters
              for(var param in params){
                  this.soapParams.add(param, params[param]);
              }
              //Create Callback
              var soapCallback = function (e, status) {
                  if (e == null || e.constructor.toString().indexOf("function Error()") != -1) {
                      reject("Unable to contat the server: " + status);
                  } else {
                      resolve(e);
                  }
              }			
              this.soapClient.invoke(url, action, this.soapParams, true, soapCallback);
          });
          }
      setCredentials(username, password){
          this.soapClient.username = username;
          this.soapClient.password = password;
      }
  }
// import { Injectable } from '@angular/core';
// import {Http, Headers} from '@angular/http';
// import SOAPClient from '../../soapclient.js'
// import 'rxjs/Rx';
// import {xml2json} from '../../xml2json';
// @Injectable()
// export class SoapService {

//   constructor(private http: Http) {
//   }

//   createAuthorizationHeader(headers:Headers) {
//     headers.append('Authorization', 'Basic ' +
//       btoa('')); 
//   }

//   getCompanies() {
//   	var headers = new Headers();
//   	this.createAuthorizationHeader(headers);
//   	headers.append('Accept', 'application/xml');

//   	return this.http.get('http://192.168.10.34:22000/wsa/wsa1/', {
//       headers: headers
//     }).map(res => JSON.parse(xml2json(res.text(),'  ')))
//     /*.map(data => {
//       console.log(data);
//       return [].concat.apply([], data);
//     })*/;
//   }
// }


// WEBPACK FOOTER //
// ./src/app/checkout/soap.service.ts